// newsfeed-resolver.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { UserService } from '../services/user.service';
import { SharedService } from '../services/shared.service';

@Injectable({ providedIn: 'root' })
export class RightsResolver implements Resolve<void> {
    usersToReload: string[];
    constructor(
        private httpClient: HttpClient,
        private userService: UserService,
        private sharedService: SharedService
    ) {}
    async resolve(): Promise<void> {
        try {
            const formData = new FormData();
            formData.append('option', 'reload_user_rights');
            const data = await lastValueFrom(
                this.httpClient.post<any>(
                    `hippo/ajax_navigator.php?page=pages/api/Ajax_common_lists.php&uid=${this.userService.user.uid}&page_type=json`,
                    formData,
                    {
                        observe: 'response',
                    }
                )
            );
            this.usersToReload = JSON.parse(JSON.stringify(data.body.result));
            console.log(this.usersToReload);

            if (
                this.userService.user.id &&
                this.usersToReload.includes(this.userService.user.id)
            ) {
                await this.reloadRights();
            }
        } catch (error) {
            console.log(error);
            const result = error?.error?.result;

            // Ignore cancelled/aborted requests (e.g., due to navigation)
            if (
                error?.name === 'AbortError' ||
                error?.status === 0 ||
                error?.statusText === 'Unknown Error'
            ) {
                return;
            }

            if (
                result === 'page access denied' ||
                result?.message === 'page access denied'
            ) {
            } else {
                this.sharedService.showDataNotLoaded(
                    error,
                    'RightsResolver',
                    'resolve'
                );
            }
        }
    }

    async reloadRights() {
        try {
            const formData = new FormData();
            formData.append('option', 'user_privileges');
            const data = await lastValueFrom(
                this.httpClient.post<any>(
                    `hippo/ajax_navigator.php?page=pages/api/Ajax_user_data.php&uid=${this.userService.user.uid}&page_type=json`,
                    formData,
                    {
                        observe: 'response',
                    }
                )
            );
            this.userService.user.privileges = JSON.parse(
                JSON.stringify(data.body.result)
            );
            console.log('rights reloaded');
        } catch (error) {
            console.log(error);
            if (
                error?.name === 'AbortError' ||
                error?.status === 0 ||
                error?.statusText === 'Unknown Error'
            ) {
                return;
            }
            this.sharedService.showDataNotLoaded(
                error,
                'RightsResolver',
                'reloadRights'
            );
        }
    }
}
